import { FC } from "react";

import { IconUser } from "@/components/_icons/IconUser";
import { cn } from "@/lib/cn";

interface DatatableAssigneeDisplayViewProps {
  className?: string;
  displayValue: string;
}

export const DatatableAssigneeDisplayView: FC<DatatableAssigneeDisplayViewProps> = ({ className, displayValue }) => {
  return (
    <>
      <IconUser className={cn("h-4 w-4 text-foreground/60", className)} />
      <span className="text-xs">{displayValue}</span>
    </>
  );
};
